import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { ChartOptions, ChartType } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';

@Component({
  selector: 'recrewt-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss'],
})
export class LineChartComponent implements OnInit, OnChanges {
  @Input() public labels: any[] = ['', '', '', '', '', ''];

  @Input() public data: any[] = [{ data: [0, 113, 431, 92, 2, 212, 0], label: 'Sample' }];

  @ViewChild(BaseChartDirective) chart?: BaseChartDirective;

  public lineChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.5,
      },
    },
    scales: {
      x: {
        ticks: {
          autoSkip: true,
          maxTicksLimit: 12,
        },
      },
      y: {
        ticks: {
          maxTicksLimit: 5,
          callback(value) {
            if (+value % 1 === 0) {
              return value;
            }
          },
        },
      },
    },
  };

  public setColor(): void {
    for (let i = 0; i < Math.min(this.lineChartColors.length, this.data.length); i++) {
      this.data[i].borderColor = this.lineChartColors[i].borderColor;
      this.data[i].backgroundColor = this.lineChartColors[i].backgroundColor;
      this.data[i].pointBackgroundColor = this.lineChartColors[i].backgroundColor;
      this.data[i].pointHoverBorderColor = this.lineChartColors[i].backgroundColor;
      this.data[i].fill = 'origin';
    }

    this.chart?.update();
  }

  public lineChartColors: any[] = [
    {
      borderColor: '#ff8f00',
      backgroundColor: '#ff8f0044',
    },
    {
      borderColor: '#e53a7d',
      backgroundColor: '#e53a7d44',
    },
    {
      borderColor: '#80093C',
      backgroundColor: '#80093C44',
    },
    {
      borderColor: '#c73c3c',
      backgroundColor: '#c73c3c44',
    },
    {
      borderColor: '#753659',
      backgroundColor: '#75365944',
    },
    {
      borderColor: '#b56048',
      backgroundColor: '#b5604844',
    },
  ];

  public lineChartLegend = true;

  public lineChartType: ChartType = 'line';

  public lineChartPlugins = [];

  ngOnInit() {
    this.setColor();
  }

  ngOnChanges() {
    this.setColor();
  }
}
